module.exports = __webpack_public_path__ + "img/20220225151409842tzt.03780178.png";